import React from 'react';

/**
 * ShipmentsTable - Table view component for Shipments page
 * Displays shipments in a table format with columns for shipment details
 */
const ShipmentsTable = ({
  shipments,
  onViewShipment,
  formatDate
}) => {
  return (
    <div className="shipments-table-container">
      <table className="shipments-table">
        <thead>
          <tr>
            <th>Shipment #</th>
            <th>Customer</th>
            <th>Invoice #</th>
            <th>Pallets</th>
            <th>Total Weight</th>
            <th>Status</th>
            <th>Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {shipments.map((shipment) => (
            <tr key={shipment.id}>
              <td className="shipment-number">
                <span className="clickable-link" onClick={() => onViewShipment(shipment)}>
                  {shipment.shipment_number}
                </span>
                {Number(shipment.pallet_count) > 0 && Number(shipment.verified_count) === Number(shipment.pallet_count) && (
                  <span className="verified-check" title="All pallets verified">
                    <svg viewBox="0 0 24 24" width="16" height="16"><path fill="#fff" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
                  </span>
                )}
              </td>
              <td>{shipment.customer_name}</td>
              <td>{shipment.invoice_number || '-'}</td>
              <td>{shipment.pallet_count} pallets</td>
              <td>{parseFloat(shipment.total_weight || 0).toFixed(2)} kg</td>
              <td>
                <span className={`status-badge status-${shipment.status || 'pending'}`}>
                  {shipment.status === 'shipped' ? 'Shipped' : 'Pending'}
                </span>
                {shipment.status !== 'shipped' && (
                  shipment.bill_path ? (
                    <span className="bill-indicator has-bill" title="Bill attached">📎</span>
                  ) : (
                    <span className="bill-indicator no-bill" title="No bill uploaded yet">No bill</span>
                  )
                )}
              </td>
              <td>{formatDate(shipment.created_at)}</td>
              <td>
                <button
                  className="action-btn view"
                  onClick={() => onViewShipment(shipment)}
                >
                  View
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ShipmentsTable;
